<template>
<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0)">
<path d="M12.0001 3.48965H1.45846C1.3286 3.48965 1.21628 3.53704 1.12148 3.63189C1.02663 3.72669 0.979248 3.83901 0.979248 3.96879V11.1563C0.979248 11.286 1.02663 11.3984 1.12148 11.4932C1.21628 11.588 1.3286 11.6355 1.45846 11.6355H12.0001C12.1298 11.6355 12.2421 11.588 12.337 11.4932C12.4317 11.3984 12.4791 11.286 12.4791 11.1563V3.96879C12.4791 3.83893 12.4319 3.72672 12.337 3.63189C12.2422 3.53704 12.1298 3.48965 12.0001 3.48965ZM8.02433 5.74321C7.92958 5.83803 7.81721 5.88544 7.68743 5.88544H5.77077C5.64107 5.88544 5.52876 5.83801 5.43388 5.74321C5.33908 5.64836 5.29164 5.53609 5.29164 5.40623C5.29164 5.27648 5.33908 5.16416 5.43388 5.06934C5.52873 4.97449 5.64105 4.92705 5.77077 4.92705H7.68762C7.81729 4.92705 7.92958 4.97449 8.02451 5.06934C8.11928 5.16414 8.16667 5.27645 8.16667 5.40623C8.16667 5.53607 8.11918 5.64836 8.02433 5.74321Z" fill="#B8CDD7"/>
<path d="M12.8161 0.277735C12.7213 0.182884 12.609 0.135498 12.4792 0.135498H0.979158C0.849403 0.135498 0.737088 0.182884 0.642263 0.277735C0.547439 0.372533 0.5 0.484849 0.5 0.61463V2.53129C0.5 2.66104 0.547439 2.77331 0.642289 2.86818C0.737114 2.96303 0.849404 3.01042 0.979184 3.01042H12.4791C12.6088 3.01042 12.7212 2.96303 12.8161 2.86818C12.9109 2.77333 12.9583 2.66107 12.9583 2.53129V0.61463C12.9583 0.48477 12.9109 0.372533 12.8161 0.277735Z" fill="#B8CDD7"/>
</g>
<defs>
<clipPath id="clip0">
<path d="M0.5 0H13V12H0.5V0Z" fill="white"/>
</clipPath>
</defs>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>